import React from "react";

const AccordionWrapper = (props) => {
  return (
    <div
      style={
        props.mobileView
          ? {
              position: "relative",
              width: "100%",
              display: "flex",
              flexDirection: "row",
              justifyContent:
                props.element.accordion.mobileStyle.alignment == "left"
                  ? "flex-start"
                  : props.element.accordion.mobileStyle.alignment == "center"
                  ? "center"
                  : "flex-end",
            }
          : {
              position: "relative",
              width: "100%",
              display: "flex",
              flexDirection: "row",
              justifyContent:
                props.element.accordion.desktopStyle.alignment == "left"
                  ? "flex-start"
                  : props.element.accordion.desktopStyle.alignment == "center"
                  ? "center"
                  : "flex-end",
            }
      }
    >
      <div
        className="accordion-wrapper"
        style={
          props.mobileView
            ? {
                width:
                  props.element.accordion.mobileStyle.width +
                  props.element.accordion.widthUnit,
                display: "flex",
                flexDirection: "column",
                borderStyle: "solid",
                borderColor: `rgba(${props.element.accordion.mobileStyle.borderColor.r},${props.element.accordion.mobileStyle.borderColor.g},${props.element.accordion.mobileStyle.borderColor.b},${props.element.accordion.mobileStyle.borderColor.a})`,
                borderWidth:
                  props.element.accordion.mobileStyle.borderWidth + "px",
                borderRadius:
                  props.element.accordion.mobileStyle.borderRadius + "px",
                marginTop:
                  props.element.accordion.mobileStyle.marginTop +
                  props.element.accordion.marginUnit,
                marginBottom:
                  props.element.accordion.mobileStyle.marginBottom +
                  props.element.accordion.marginUnit,
              }
            : {
                width:
                  props.element.accordion.desktopStyle.width +
                  props.element.accordion.widthUnit,
                display: "flex",
                flexDirection: "column",
                borderStyle: "solid",
                borderColor: `rgba(${props.element.accordion.desktopStyle.borderColor.r},${props.element.accordion.desktopStyle.borderColor.g},${props.element.accordion.desktopStyle.borderColor.b},${props.element.accordion.desktopStyle.borderColor.a})`,
                borderWidth:
                  props.element.accordion.desktopStyle.borderWidth + "px",
                borderRadius:
                  props.element.accordion.desktopStyle.borderRadius + "px",
                marginTop:
                  props.element.accordion.desktopStyle.marginTop +
                  props.element.accordion.marginUnit,
                marginBottom:
                  props.element.accordion.desktopStyle.marginBottom +
                  props.element.accordion.marginUnit,
              }
        }
      >
        {props.children}
      </div>
    </div>
  );
};

export default AccordionWrapper;
